import * as React from 'react';

import { ILxsRegisterData } from './lxs-register.data';
import { ILxsRegisterProps } from './lxs-register.props.autogenerated';

export interface ILxsRegisterViewProps extends ILxsRegisterProps<ILxsRegisterData> {}

/**
 *
 * LxsRegister component
 * @extends {React.PureComponent<ILxsRegisterProps<ILxsRegisterData>>}
 */
class LxsRegister extends React.PureComponent<ILxsRegisterProps<ILxsRegisterData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LxsRegister;
